import { useCallback } from 'react'
import { deleteSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { leadingUrlOptions } from 'Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals'
import { useToast } from '@hooks'


export default function useDeleteUrl() {
	const { showToast } = useToast()

	const handleDeleteUrl = useCallback(id => {
		const backupOptions = leadingUrlOptions.peek()
		leadingUrlOptions.value = leadingUrlOptions.value.filter(({ value }) => value !== id)
		deleteSubmit(`${BACKEND_APIS.DASHBOARD}/delete-filters?id=${id}`)
			.catch(() => {
				showToast.error('Error deleting url')
				leadingUrlOptions.value = backupOptions
			})
	}, [])

	return {
		handleDeleteUrl
	}
}